import { Layout } from 'antd';
import './about.css';

const { Content } = Layout;

function About() {
  return (
    <Layout>
      <Content>
        <div className="about">
          <h2>About Us</h2>
          <p>Welcome to Gila Dynamics - an app development company dedicated to creating simple, fun apps for consumers on iOS and Android.</p>

          <p>At Gila Dynamics, we were founded by Robert Al Malak and Sam Morton with a passion for developing our own apps that enhance daily life. We focus on building simple apps that are easy to use, whether they help with productivity, entertainment, or just making routines more enjoyable.</p>

          <p>Robert Al Malak and Sam Morton are committed to staying up-to-date with the latest technologies and trends in mobile app development. This allows us to create innovative apps that users love and rely on.</p>

          <p>At Gila Dynamics, we believe that great apps can make a big difference in people's lives. That's why we strive to deliver high-quality, reliable, and engaging apps for iOS and Android users everywhere.</p>

          <p>If you're looking for apps that make life simpler and more fun, check out what we're building. We're always working on new ideas to bring to the App Store and Google Play.</p>
        </div>
      </Content>
    </Layout>
  );
}

export default About;
